import React, { useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '@/App';

// Laedt ein Bild auf den eigenen Server (Backend /api/uploads/image) und gibt die
// relative URL (/uploads/...) zurueck. Ersetzt Bild-Links auf Google Drive/Unsplash,
// damit Besucher keine Verbindung zu Dritten aufbauen (Datenschutz).
const ImageUploadButton = ({ onUploaded, label = 'Bild hochladen', testId }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) {
      toast.error('Das Bild ist größer als 8 MB.');
      return;
    }
    setBusy(true);
    try {
      const body = new FormData();
      body.append('file', file);
      const token = localStorage.getItem('token');
      const res = await axios.post(`${API}/uploads/image`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      onUploaded(res.data.url);
      toast.success('Bild hochgeladen');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Hochladen fehlgeschlagen');
    } finally {
      setBusy(false);
    }
  };

  const [library, setLibrary] = useState(null);

  const openLibrary = async () => {
    if (library) {
      setLibrary(null);
      return;
    }
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`${API}/uploads/library`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setLibrary(res.data.images || []);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Bibliothek konnte nicht geladen werden');
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/jpeg,image/png,image/webp,image/gif"
        className="hidden"
        onChange={handleFile}
        data-testid={testId ? `${testId}-file` : undefined}
      />
      <button
        type="button"
        disabled={busy}
        onClick={() => inputRef.current && inputRef.current.click()}
        className="mt-2 px-3 py-1.5 rounded-md border border-slate-300 bg-white text-sm text-slate-800 hover:bg-slate-100 disabled:opacity-60"
        data-testid={testId}
      >
        {busy ? 'Lade hoch …' : label}
      </button>
      <button
        type="button"
        onClick={openLibrary}
        className="mt-2 ml-2 px-3 py-1.5 rounded-md border border-slate-300 bg-white text-sm text-slate-800 hover:bg-slate-100"
        data-testid={testId ? `${testId}-library` : undefined}
      >
        Aus Bibliothek wählen
      </button>
      {library && (
        <select
          className="mt-2 block w-full border border-slate-300 rounded-md px-2 py-1.5 text-sm bg-white"
          defaultValue=""
          onChange={(e) => {
            if (e.target.value) {
              onUploaded(e.target.value);
              setLibrary(null);
            }
          }}
          data-testid={testId ? `${testId}-library-select` : undefined}
        >
          <option value="">{library.length ? 'Bild auswählen …' : 'Keine Bilder vorhanden'}</option>
          {library.map((img) => (
            <option key={img.url} value={img.url}>{img.name}</option>
          ))}
        </select>
      )}
    </>
  );
};

export default ImageUploadButton;
